export const ACTION_TYPES = {
	LOGIN_USER: "LOGIN_USER",
	LOGOUT_USER: "LOGOUT_USER",
	ROLE: "USER_ROLE",
	SCHOOL_ID: "SCHOOL_ID",
	TEACHER_ID: "TEACHER_ID",
	USER_INFO: "USER_INFO",
	CLASSLINK_USER: "CLASSLINK_USER",
};

// NOTE: auth/identity keys use sessionStorage (per-tab) so two tabs on the same
// origin (e.g. admin + teacher) keep independent sessions and never clash.
export const loginUser = (data) => {
	// SET YOUR LOGIN INFO HERE
	sessionStorage.setItem("cms_isLoggedIn", true);
	return {
		type: ACTION_TYPES.LOGIN_USER,
		...data,
	};
};

export const logOutUser = () => {
	sessionStorage.removeItem("cms_isLoggedIn");
	sessionStorage.removeItem("cms_accessToken");
	sessionStorage.removeItem("cms_userInfo");
	return {
		type: ACTION_TYPES.LOGOUT_USER,
	};
};

export const userRole = (role) => {
	return {
		type: ACTION_TYPES.ROLE,
		role,
	};
};

export const reduxSchoolId = (school_id) => {
	return {
		type: ACTION_TYPES.SCHOOL_ID,
		school_id,
	};
};

export const reduxTeacherId = (teacher_id) => {
	return {
		type: ACTION_TYPES.TEACHER_ID,
		teacher_id,
	};
};

export const userInfo = (data) => {
	sessionStorage.setItem("cms_userInfo", JSON.stringify(data));
	return {
		type: ACTION_TYPES.USER_INFO,
		userInfo: data,
	};
};

export const classLinkUser = (value) => {
	return {
		type: ACTION_TYPES.CLASSLINK_USER,
		isFromClassLink: value,
	};
};
